/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PatientProcedureMedicine from './patient-procedure-medicine';
import PatientProcedureMedicineDetail from './patient-procedure-medicine-detail';
import PatientProcedureMedicineUpdate from './patient-procedure-medicine-update';
import PatientProcedureMedicineDeleteDialog from './patient-procedure-medicine-delete-dialog';

const PatientProcedureMedicineRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PatientProcedureMedicine />} />
    <Route path="new" element={<PatientProcedureMedicineUpdate />} />
    <Route path=":id">
      <Route index element={<PatientProcedureMedicineDetail />} />
      <Route path="edit" element={<PatientProcedureMedicineUpdate />} />
      <Route path="delete" element={<PatientProcedureMedicineDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PatientProcedureMedicineRoutes;
